import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestService } from './test.service';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from './auth/auth.module';
import { AccountService } from './account.service';
import { HttpModule } from '@angular/http';
import { ContractService } from './contract.service';
import { FlightHoursService } from './flight-hours.service';
import { AdminService } from './Admin.service';
import { PayInvoiceService } from './pay-invoice.service';
import { ContactService } from './contact.service';
import { QuestionService } from './question.service';
import { DataService } from './data.service';
import { VendorService } from './vendor.service';
import { EmailService } from './email.service';
// import { ContractResolverService } from './contract-resolver.service';
import { MarketService } from './market.service';
import * as Cookie from 'js-cookie';

// export function tokenGetter(): string {
//   const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
//   if (isIEOrEdge) {
//    // alert(Cookie.get('token'));
//     return Cookie.get('token');

//   } else {
//    // alert(localStorage.getItem('token'));
//     return localStorage.getItem('token');
//   }
// }

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    HttpModule,
    AuthModule
  ],
  declarations: []
})
export class ServicesModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ServicesModule,
      providers: [
        TestService,
        AccountService,
        ContractService,
        //  ContractResolverService,
        FlightHoursService,
        AdminService,
        ContactService,
        PayInvoiceService,
        QuestionService,
        DataService,
        VendorService,
        EmailService,
        MarketService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts